import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { PalletActions } from "redux/actions";

interface IPalletState extends IBaseReducerState {}

const initialState: IPalletState = {
  action: PalletActions.prefix,
  prefix: PalletActions.prefix,
};

const clearAction = (state: IPalletState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = PalletActions.prefix;
  });

const UserReducer = ReduxHelper.createHandleReducer<IPalletState>(
  initialState,
  (builder) => {
    builder.addCase(PalletActions.clearAction.request, clearAction);
  }
);

export default UserReducer;
